import { computed, unref } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import request from '@/requests'
import { STATUS_OK } from '@/constants'

// The detail components of an address's task (the same the task details show): ODA status, tickets
// with their photos. One cached request per address + task type, shared by the call centre tabs.
export function useTaskDetail(address, taskType, project) {
  return useQuery({
    queryKey: computed(() => ['callCentreTaskDetail', unref(address), unref(taskType), unref(project)]),
    queryFn: async () => {
      const response = await request.tasks.getTaskDetail(unref(taskType), unref(address), unref(project))
      return response.status === STATUS_OK ? response.data?.components ?? null : null
    },
    enabled: computed(() => !!unref(taskType) && !!unref(address)),
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
    // heavy request (task, tickets, Eleena): no automatic retries on a failure
    retry: false,
  })
}
